/**
 * Ryan O'Dowd
 * 2021-10-08
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode, safeAreaInsets, windowWidth}) => {
  return {
    keyboardAvoidingContainer: {
      flex: 1,
      marginBottom: safeAreaInsets.bottom,
    },
    chatContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    messagesContainer: {
      flex: 1,
      width: Math.min(windowWidth, 800),
      maxWidth: Math.min(windowWidth, 800),
      margin: 0,
      backgroundColor: isDarkMode ? `${colors.primaryExtraDark}44` : `${colors.primaryDark}44`,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
    },
    width100: {
      width: '100%',
    },
    messagesList: {
      marginBottom: globalScale * 8,
    },
    newMessageContainer: {
      flexDirection: 'row',
      backgroundColor: isDarkMode ? colors.completeBg : colors.white, // @TODO: should be darker in dark mode
      justifyContent: 'center',
      alignItems: 'center',
      padding: globalScale * 4,
    },
    newMessage: {
      flex: 0,
      marginTop: 0,
      marginBottom: 0,
      marginLeft: globalScale * 8,
      fontSize: globalScale * 16,
    },
    saveMessageIconWrapper: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignSelf: 'flex-end',
      width: globalScale * 40,
      minHeight: globalScale * 40, // @TODO: should this have the globalScale?
      padding: globalScale * 5,
      marginRight: globalScale * 10,
      marginBottom: globalScale * 12,
    },
    saveMessageIcon: {
      flex: 1,
      height: '100%',
      fontSize: globalScale * 30,
      color: colors.primary,
    },
    saveMessageIconDisabled: {
      color: colors.gray,
    },
  };
};

export default getStyles;
